var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',[_vm._v("Account Page")]),_c('span',[_vm._v("This page should contain the following components:")]),_vm._m(0),_c('router-link',{attrs:{"to":"/configure/user/customize"}},[_vm._v("Customize")])],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('ul',[_c('li',[_vm._v("Sign up Component")]),_c('li',[_vm._v("Log in Component")]),_c('li',[_vm._v("Email Confirmation")])])
}]

export { render, staticRenderFns }